import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const HeroSection = ({ onGetStarted, onContactSales }) => {
  return (
    <section className="relative bg-gradient-to-br from-primary/5 via-background to-secondary/5 py-16 md:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-warning/10 text-warning rounded-full mb-6 md:mb-8">
              <Icon name="AlertTriangle" size={16} />
              <span className="caption font-medium">Preliminary AI Analysis Only</span>
            </div>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-4 md:mb-6">
              AI-Powered Fire Forensics Analysis in Minutes
            </h1>
            
            <p className="text-base md:text-lg lg:text-xl text-muted-foreground mb-6 md:mb-8 max-w-2xl mx-auto lg:mx-0">
              Upload evidence once. Get standards-aligned preliminary reports + optional expert review. Fast, accurate analysis to help you decide: pursue vs. don't pursue, pay vs. deny vs. investigate.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start mb-6 md:mb-8">
              <Button 
                variant="default" 
                size="lg"
                iconName="Sparkles"
                iconPosition="left"
                onClick={onGetStarted}
                className="w-full sm:w-auto"
              >
                Start Free Report
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                iconName="Phone"
                iconPosition="left"
                onClick={onContactSales}
                className="w-full sm:w-auto"
              >
                Contact Sales
              </Button>
            </div>
            
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-success/10 text-success rounded-lg">
              <Icon name="Gift" size={20} />
              <span className="text-sm md:text-base font-medium">One free report with verified email + card on file</span>
            </div>
          </div>
          
          <div className="relative">
            <div className="bg-card border border-border rounded-xl shadow-elevation-lg p-6 md:p-8">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name="FileText" size={24} className="text-primary" />
                </div>
                <div>
                  <h3 className="font-semibold text-lg">Sample Report Preview</h3>
                  <p className="caption text-muted-foreground">15-section comprehensive analysis</p>
                </div>
              </div>
              
              <div className="space-y-3">
                {[
                  { icon: 'CheckCircle', label: 'Cover Page & Executive Summary', status: 'Complete' },
                  { icon: 'CheckCircle', label: 'Scene Documentation & Analysis', status: 'Complete' },
                  { icon: 'CheckCircle', label: 'Fire Pattern Analysis', status: 'Complete' },
                  { icon: 'CheckCircle', label: 'Origin & Cause Determination', status: 'Complete' },
                  { icon: 'CheckCircle', label: 'Standards-Aligned Methodology (NFPA 921)', status: 'Complete' }
                ]?.map((item, index) => (
                  <div key={index} className="flex items-center gap-3 p-3 bg-muted/50 rounded-lg">
                    <Icon name={item?.icon} size={20} className="text-success flex-shrink-0" />
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-medium truncate">{item?.label}</p>
                    </div>
                    <span className="caption text-success whitespace-nowrap">{item?.status}</span>
                  </div>
                ))}
              </div>
              
              <div className="mt-6 pt-6 border-t border-border">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-muted-foreground">Generated in</span>
                  <span className="font-semibold text-primary">3-5 minutes</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;